var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OrderExportButton',{staticClass:"OrderWhatsSendBudgedButton",attrs:{"order-id":_vm.orderId,"direct-export-type":{ type: 'png' },"btn-attrs":{
    icon: true,
    size: _vm.btnSize,
    class: 'btn-link btn-github btn-simple',
    noBtnText: true,
  },"btn-icon":_vm.btnIcon,"tooltip":_vm.$t('sendBudgetToCustomer')},on:{"export":_vm.handleExport}})
}
var staticRenderFns = []

export { render, staticRenderFns }